<template>
    <div class="header">
        <div class="container container-fluid h-100">
            <div class="row flex-box h-100">
                <router-link
                    to="/"
                    class="logo-link"
                >
                    <img
                        class="logo"
                        src="../assets/images/logo.png"
                        alt="logo"
                    >
                </router-link>
                <div
                    class="c-lang"
                    @mouseleave="hideDropdownMenu()"
                    @click="toggleDropdownMenu()"
                >
                    <span>{{$store.state.currentLang}}</span>
                    <svg
                        class="bi bi-caret-down-fill ml-1"
                        width="1em"
                        height="1em"
                        viewBox="0 0 16 16"
                        fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 01.753 1.659l-4.796 5.48a1 1 0 01-1.506 0z"></path>
                    </svg>
                    <transition name="slide-fade">
                        <div
                            class="dropdown-menu-lang text-center"
                            v-show="$store.state.isShowLangMenu"
                        >
                            <p
                                :class="$store.state.currentLang===lang.name?'active':''"
                                v-for="(lang,key) in languages"
                                :key="key"
                                @click.stop="changeLang(lang.type)"
                            >{{lang.name}}</p>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommonHeader',
    data() {
        return {
            languages: [
                {
                    type: 'en',
                    name: 'English'
                },
                {
                    type: 'zh',
                    name: '中文'
                },
                {
                    type: 'fr',
                    name: 'Français'
                },
                {
                    type: 'ge',
                    name: 'Deutsch'
                },
                {
                    type: 'it',
                    name: 'Italiano'
                },
                {
                    type: 'es',
                    name: 'Español'
                },
                {
                    type: 'jp',
                    name: 'にほんご'
                },
                {
                    type: 'pt',
                    name: 'Português'
                },
                {
                    type: 'ar',
                    name: 'عربى'
                },
                {
                    type: 'he',
                    name: 'עברית'
                }
            ],
        }
    },
    mounted() {
        // 获取本地存储的当前语言
        let currentLang = localStorage.getItem('locale')
        this.setMenuLang(currentLang)
    },
    methods: {
        // 切换语言
        changeLang(lang) {
            localStorage.setItem('locale', lang)
            this.$i18n.locale = lang
            this.setMenuLang(lang)
            this.hideDropdownMenu()
        },
        // 设置菜单语言展示
        setMenuLang(lang) {
            let _this = this
            _this.languages.forEach(item => {
                if (item.type === lang) {
                    _this.$store.commit('setLanguage', item.name)
                }
            })
        },
        // 显示下拉菜单
        showDropdownMenu() {
            this.$store.state.isShowLangMenu = true
        },
        // 隐藏下拉菜单
        hideDropdownMenu() {
            this.$store.state.isShowLangMenu = false
        },
        // 切换下拉菜单
        toggleDropdownMenu() {
            this.$store.state.isShowLangMenu = !this.$store.state.isShowLangMenu
        }
    },
}
</script>

<style lang="scss" scoped>
.header {
    height: 85px;
    position: fixed;
    top: 0;
    z-index: 13;
    width: 100%;
    background-color: #fff;
}

.logo-link {
    display: inline-block;
    // padding: 10px;
}

.logo {
    width: 140px;
}

.bi-caret-down-fill {
    width: 11px;
}

.c-lang {
    position: relative;
    cursor: pointer;
}

.dropdown-menu-lang {
    position: absolute;
    top: 25px;
    right: 0;
    box-shadow: 0 0 10px #ccc;
    background: #fff;
    cursor: pointer;
}

.dropdown-menu-lang p {
    margin: 0;
    padding: 5px 15px;
}

.dropdown-menu-lang p:hover {
    background: #f2f2f2;
}

.active {
    color: #c6a85b;
}

.slide-fade-enter-active {
    transition: all 0.2s ease;
}

.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .header {
        height: 45px;
        border: 1px solid #eeeeee;
    }
    .logo {
        width: 70px;
    }
}
</style>
